import { type IIdWithDisplay, useToasts, isOk } from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { useCheckIsEntityNotInUse } from './useCheckEntityIsNotInUse';

export function useIsThisEntityNotInUse<T extends IIdWithDisplay>(obj: T, apiResourceType: string) {
    const { pushAllToasts } = useToasts();
    const { checkIsNotInUse, isCheckNotInUsePending } = useCheckIsEntityNotInUse();

    const isThisEntityNotInUse = useCallback(async () => {
        if (isCheckNotInUsePending) {
            return false;
        }

        const canDeleteResult = await checkIsNotInUse(obj, apiResourceType);
        pushAllToasts(canDeleteResult.messages);

        return isOk(canDeleteResult) && canDeleteResult.data;
    }, [isCheckNotInUsePending, obj, apiResourceType, checkIsNotInUse, pushAllToasts]);

    return isThisEntityNotInUse;
}
